const deferElement = (element, callback) => {
  if (document.querySelectorAll(element).length > 0) {
    callback(element);
  } else {
    setTimeout(() => { deferElement(element, callback) }, 50);
  }
}

function localeShopify() {
  var langSubstring = '';
  var stringUrl = window.location.href.split('/');

  for (var stringPart in stringUrl) {
    if (stringUrl[stringPart] == Shopify.locale.toLowerCase()) {
      langSubstring = Shopify.locale.toLowerCase().concat('/');
    }
  }
  return langSubstring;
}

var reviewsSection = document.querySelector(
  '.product-reviews.product-reviews--full'
);
var reviewsConfig = { attributes: true, childList: true, subtree: true };
var callback = function (mutationsList, observer) {
  for (var mutation of mutationsList) {
    if (mutation.type == 'childList') {
      var reviewsTitle = document.querySelector(
        '.product-reviews.product-reviews--full .spr-header-title-top'
      );
      var reviewsWrite = document.querySelector(
        '.product-reviews.product-reviews--full .spr-summary-actions-newreview'
      );
      var reviewFormName = document.querySelector(
        '.product-reviews.product-reviews--full .spr-form-contact-name .spr-form-label'
      );
      var reviewFormNameInput = document.querySelector(
        '.product-reviews.product-reviews--full .spr-form-contact-name .spr-form-input'
      );
      var reviewFormRating = document.querySelector(
        '.product-reviews.product-reviews--full .spr-form-review-rating .spr-form-label'
      );
      var reviewTitle = document.querySelector(
        '.product-reviews.product-reviews--full .spr-form-review-title .spr-form-label'
      );
      var reviewTitleInput = document.querySelector(
        '.product-reviews.product-reviews--full .spr-form-review-title .spr-form-input'
      );
      var reviewDesc = document.querySelector(
        '.product-reviews.product-reviews--full .spr-form-review-body .spr-form-label'
      );
      var reviewDescInput = document.querySelector(
        '.product-reviews.product-reviews--full .spr-form-review-body .spr-form-input-textarea'
      );
      var reviewSubmit = document.querySelector(
        '.product-reviews.product-reviews--full .spr-form-actions .spr-button-primary'
      );
      if (reviewsTitle && !reviewsTitle.hasAttribute('data-translated')) {
        reviewsTitle.textContent = theme.strings.customerReviews;
        reviewsTitle.setAttribute('data-translated', 'true');
      }
      if (reviewsWrite && !reviewsWrite.hasAttribute('data-translated')) {
        reviewsWrite.textContent = theme.strings.writeReview;
        reviewsWrite.setAttribute('data-translated', 'true');
      }
      if (
        reviewFormName &&
        !reviewFormName.hasAttribute('data-translated')
      ) {
        reviewFormName.textContent = theme.strings.reviewFormName;
        reviewFormName.setAttribute('data-translated', 'true');
      }
      if (
        reviewFormNameInput &&
        !reviewFormNameInput.hasAttribute('data-translated')
      ) {
        reviewFormNameInput.setAttribute(
          'placeholder',
          theme.strings.reviewFormNameInput
        );
        reviewFormNameInput.setAttribute('data-translated', 'true');
      }
      if (
        reviewFormRating &&
        !reviewFormRating.hasAttribute('data-translated')
      ) {
        reviewFormRating.textContent = theme.strings.reviewFormRating;
        reviewFormRating.setAttribute('data-translated', 'true');
      }
      if (reviewTitle && !reviewTitle.hasAttribute('data-translated')) {
        reviewTitle.textContent = theme.strings.reviewTitle;
        reviewTitle.setAttribute('data-translated', 'true');
      }
      if (
        reviewTitleInput &&
        !reviewTitleInput.hasAttribute('data-translated')
      ) {
        reviewTitleInput.setAttribute(
          'placeholder',
          theme.strings.reviewTitleInput
        );
        reviewTitleInput.setAttribute('data-translated', 'true');
      }
      if (reviewDesc && !reviewDesc.hasAttribute('data-translated')) {
        reviewDesc.textContent = theme.strings.reviewDesc;
        reviewDesc.setAttribute('data-translated', 'true');
      }
      if (
        reviewDescInput &&
        !reviewDescInput.hasAttribute('data-translated')
      ) {
        reviewDescInput.setAttribute(
          'placeholder',
          theme.strings.reviewDescInput
        );
        reviewDescInput.setAttribute('data-translated', 'true');
      }
      if (reviewSubmit && !reviewSubmit.hasAttribute('data-translated')) {
        reviewSubmit.textContent = theme.strings.reviewSubmit;
        reviewSubmit.setAttribute('value', theme.strings.reviewSubmit);
        reviewSubmit.setAttribute('data-translated', 'true');
      }
      observer.disconnect();
    }
  }
};

var observer = new MutationObserver(callback);
if (reviewsSection) {
  observer.observe(reviewsSection, reviewsConfig);
}

defer('jQuery', () => {
  $(document).ready(() => {
    var locale = localeShopify();

    var carouselOptions = {
      lazyLoad: 'ondemand',
      arrows: true,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      adaptiveHeight: true,
      prevArrow: '<span class="slick-prev lnr lnr-arrow-left"></span>',
      nextArrow: '<span class="slick-next lnr lnr-arrow-right"></span>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        }
      ]
    };

    var carouselOptions4Items = {
      lazyLoad: 'ondemand',
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      adaptiveHeight: true,
      prevArrow:
        `<span class="slick-prev lnr lnr-chevron-left">${document.getElementById('prevArrowTemplate')?.outerHTML}</span>`,
      nextArrow:
        `<span class="slick-next lnr lnr-chevron-right">${document.getElementById('nextArrowTemplate')?.outerHTML}</span>`,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }
      ]
    };

    $('.similar-products-carousel').slick(carouselOptions);
    setTimeout(() => {
      $('.also-bought-carousel').find('.grid').slick(carouselOptions);
    }, 2000);

    var productRelatedItems = 0;

    $('.product-related-items-carousel').each(function () {
      var skuItems = $(this).data('sku').toString();
      productRelatedItems += skuItems.includes(',')
        ? skuItems.split(',').length
        : 1;
    });

    $('.product-related-items-added').on('change', function () {
      if (parseInt($(this).val()) == productRelatedItems) {
        $('.product-related-items-carousel').slick(carouselOptions4Items);
        $("span[data-products='spare-parts']").css('width', '100%');
        $("span[data-products='accessories']").css('width', '100%');

        showCarouselLabel('spare-parts');
        showCarouselLabel('accessories');
      }
    });

    $('.product-related-items-carousel').each(function () {
      fetchProductsbySKU( this, locale );
    });

    var total_slide = $(
      '.Product__variantGallery--is-active .product-image-main img'
    ).length;

    if (
      $($('.product-image-main img')[0]).parents('.slick-dotted').length > 0
    ) {
      total_slide = total_slide - 2;
    }

    $('.number-slide').text(1);
    $('.total-slide').text(total_slide);

    $("[id^='ProductPhotos']").on(
      'afterChange',
      function (event, slick, currentSlide) {
        $('.number-slide').text(currentSlide + 1);
      }
    );

    // Funzione al variare della variante
    $('.variant-option-selector:first').on('change', function (e) {
      var selectedOption = $('.variant-option-selector option:selected'),
          customMetafields = selectedOption.data('metafields-custom');

      $('.size-guide-dimension').html(customMetafields.dimension);
      changeVideoVariant();

      let related_replacement = $('.variant-option-selector option:selected')
        .data('metafields-spare')
        .toString();
      let related_accessories = $('.variant-option-selector option:selected')
        .data('metafields-accessories')
        .toString();
      document
        .getElementById('spare-parts-carusel')
        .setAttribute('data-sku', related_replacement);
      document
        .getElementById('accessories-carusel')
        .setAttribute('data-sku', related_accessories);
      $("span[data-products='spare-parts']").removeClass('active');
      $("span[data-products='accessories']").removeClass('active');

      setTimeout(() => {
        $('.product-related-items-carousel').each(function () {
          $('.product-related-items-carousel').slick('unslick');
          $('.product-related-items-carousel').children().remove();
        });
        callProductbySku(locale);
      }, 1500);
    });

  /* Reviews Layout */
    deferElement('.spr-content', function (element) {
      $('.spr-summary-actions-newreview')
        .addClass('btn')
        .insertAfter($('#shopify-product-reviews .spr-content'));
      $('.spr-header-title')
        .removeClass('spr-header-title')
        .addClass('spr-header-title-top');
      $('#shopify-product-reviews-title')
        .insertAfter($('#shopify-product-reviews .spr-header-title-top'))
        .addClass('spr-header-title');
      $('.spr-form').insertAfter(
        $('#shopify-product-reviews .spr-summary-actions-newreview')
      );

      $('.spr-review-header-byline').each(function () {
        $(this).insertBefore(
          $(this).closest('.spr-review').children('.spr-review-footer')
        );
        $(this).replaceWith(
          $(
            '<div class="spr-review-header-byline">' + $(this).text() + '</div>'
          )
        );
      });

      $(
        '#shopify-product-reviews-objects, #shopify-product-reviews .spr-summary'
      ).remove();

      $('#shopify-product-reviews')
        .css('visibility', 'visible')
        .hide()
        .fadeIn('slow');

      $('#shopify-product-reviews .spr-reviews').slick({
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow:
          '<span class="slick-prev lnr lnr-arrow-left">' +
          $('#shopify-product-reviews-prev').html() +
          '</span>',
        nextArrow:
          '<span class="slick-next lnr lnr-arrow-right">' +
          $('#shopify-product-reviews-next').html() +
          '</span>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  
    $('.product__thumb-item:nth-child(4n)').click(function () {
      $('.product__thumbs').addClass('top-blur-effect');
      $('.product__thumbs').removeClass('bottom-blur-effect');
    });

    $('.product__thumb-item:nth-child(-n+3)').click(function () {
      $('.product__thumbs').addClass('bottom-blur-effect');
      $('.product__thumbs').removeClass('top-blur-effect');
    });
  });

  // Funzione per cambiare video al cambio della variante
  function changeVideoVariant() {
    const contentVideoW = document.getElementById('content_video-wrapper');
    let videoUrlArray = $('.variant-option-selector option:selected')
      .data('metafieldsVideo')
      .split(',');
    videoUrlArray.splice(-1, 1);
    $('.product-content__video-variant').remove();
    videoUrlArray.forEach((videoV) => {
      if (!videoV == '') {
        // Creo il div contenente il video e lo appendo all'interno di ContenVideoW
        let containerVideo = document.createElement('div');
        containerVideo.className =
          'hero__text-wrap product-content__video-variant active';
        let videoId = videoV.split('/').pop();
        let videoClass = videoV.includes('.mp4')
          ? 'product-video-trigger--mp4'
          : '';
        containerVideo.innerHTML =
          `<div class="page-width">
          <div class="hero__link">
            <div class="animation-cropper">
              <div class="animation-contents">
                <a class="product-content__videoUrl rte__image ${videoClass}" href="${videoV}" aria-expanded="false">    
                  <img src="https://img.youtube.com/vi/${videoId}/default.jpg">
                  <svg class="Icon Icon--play" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 320.001 320.001"
                    style="enable-background:new 0 0 320.001 320.001;" xml:space="preserve">
                    <path d="M295.84,146.049l-256-144c-4.96-2.784-11.008-2.72-15.904,0.128C19.008,5.057,16,10.305,16,16.001v288
                        c0,5.696,3.008,10.944,7.936,13.824c2.496,1.44,5.28,2.176,8.064,2.176c2.688,0,5.408-0.672,7.84-2.048l256-144
                        c5.024-2.848,8.16-8.16,8.16-13.952S300.864,148.897,295.84,146.049z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>`;
        contentVideoW.append(containerVideo);
        theme.videoModal();
      }
    });
  }

  // Funzione per visualizzare la label dei caroselli accessori e ricambi
  function showCarouselLabel(carouselType) {
    let carousel = $("[data-products='" + carouselType + "']").find(
      '.slick-track'
    )[0];

    if (carousel.childElementCount > 0) {
      $("span[data-products='" + carouselType + "']").addClass('active');
    }
  }

  // Chiamata al variare della variante per i caroselli ricambi-accessori
  function callProductbySku(locale) {
    Array.from(
      document.querySelectorAll('.product-related-items-carousel')
    ).forEach((prod) => { fetchProductsbySKU(prod, locale) });
  }

  function fetchProductsbySKU(prod, locale) {
    var itemsSection = prod;
    let carouselType = itemsSection.getAttribute('data-products').toString();
    var skuItems = prod.getAttribute('data-sku').toString();

    if (skuItems.includes(',') == true) {
      var skuList = skuItems.split(',');
    } else if (!skuItems.includes(',')) {
      var skuList = [skuItems];
    }

    let countSkuCall = 0;
    for (const sku of skuList) {
      $.getJSON(
        '/search?type=product&q=variants.sku:' + sku + '&view=json'
      ).done(function (responseBySku) {
        if (responseBySku.products.length > 0) {
          var currentVariantId = responseBySku.products[0].variants[0].id;
          for (const variant of responseBySku.products[0].variants) {
            if (variant.sku == sku) {
              currentVariantId = variant.id;
            }
          }
          $.get(
            '/' +
              locale +
              'products/' +
              responseBySku.products[0].handle +
              '/' +
              currentVariantId +
              '?view=json'
          )
            .done(function (responseByHandle) {
              $(itemsSection).append(responseByHandle);
              countSkuCall += 1;
              if (countSkuCall == skuList.length) {
                $(itemsSection).slick({
                  lazyLoad: 'ondemand',
                  arrows: true,
                  infinite: true,
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  adaptiveHeight: true,
                  prevArrow:
                    `<span class="slick-prev lnr lnr-chevron-left">${document.getElementById('prevArrowTemplate')?.outerHTML}</span>`,
                  nextArrow:
                    `<span class="slick-next lnr lnr-chevron-right">${document.getElementById('nextArrowTemplate')?.outerHTML}</span>`,
                  responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 1201,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                      }
                    },
                    {
                      breakpoint: 1400,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                      }
                    }
                  ]
                });
                setTimeout(() => {
                  $(itemsSection).slick('setPosition');
                }, 500);
                showCarouselLabel(carouselType);
              }
            })
            .always(function () {
              $('.product-related-items-added').val(
                parseInt($('.product-related-items-added').val()) + 1
              );
              $('.product-related-items-added').trigger('change');

              // wishlistBoxSize();
            });
        } else {
          countSkuCall += 1;
          $('.product-related-items-added').val(
            parseInt($('.product-related-items-added').val()) + 1
          );
          $('.product-related-items-added').trigger('change');
        }
      });
    }
  }
});
